import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { DayWiseProducitonAnalysisModel } from './day-wise-production-analysis.model';

export class DaywiseAnalysisResponseModel extends GlobalResponseObject {
    data?: DayWiseProducitonAnalysisModel;

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, errorCode:number, internalMessage:string, data?: DayWiseProducitonAnalysisModel){
        super(status,errorCode,internalMessage);
        this.data = data;
    }
}